import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import SEO from './SEO';

const HomeRedirect: React.FC = () => {
  const { currentUser, climberProfile, lastVisitedGym } = useAuth();
  const [loading, setLoading] = useState(true);
  const [redirectPath, setRedirectPath] = useState<string | null>(null);

  useEffect(() => {
    const determineRedirect = () => {
      if (!currentUser) {
        setRedirectPath('/login');
        setLoading(false);
        return;
      }

      // Wait for climber profile to load
      if (!climberProfile) {
        return; // Keep loading until climber profile is available
      }

      try {
        // Get gym IDs from climber profile
        const gymIds = climberProfile.getGymIds() || [];
        
        if (gymIds.length > 0) {
          // Check if last visited gym is still valid (user is still a member)
          if (lastVisitedGym && gymIds.includes(lastVisitedGym)) {
            setRedirectPath(`/gyms/${lastVisitedGym}`);
          } else {
            // User has at least one gym, redirect to first gym's detail page
            const firstGymId = gymIds[0];
            setRedirectPath(`/gyms/${firstGymId}`);
          }
        } else {
          // User has no gyms, redirect to join gym page
          setRedirectPath('/join-gym');
        }
      } catch (err) {
        console.error('Error determining redirect:', err);
        // Fallback to join gym page on error
        setRedirectPath('/join-gym');
      } finally {
        setLoading(false);
      }
    };

    determineRedirect();
  }, [currentUser, climberProfile, lastVisitedGym]);

  if (loading) {
    return (
      <>
        <SEO 
          title="Banana Cup - Climbing App | Climbing Logger with Heart Rate Monitor | BananaCup.be"
          description="Welcome to Banana Cup Climbing App - Track your climbing progress, log routes, and connect with the paraclimbing community. Features heart rate monitor integration for serious climbers."
          keywords="klimapp, klim app, climbing app, bananacup.be, banana cup, paraclimbing, paraklimmen, log climbs, climbing logger, climbing logger with heart rate monitor, paraclimbing.be"
          path="/"
        />
        <div className="loading-indicator">Loading...</div>
      </>
    );
  }

  return (
    <>
      <SEO 
        title="Banana Cup - Climbing App | Climbing Logger with Heart Rate Monitor | BananaCup.be"
        description="Welcome to Banana Cup Climbing App - Track your climbing progress, log routes, and connect with the paraclimbing community. Features heart rate monitor integration for serious climbers."
        keywords="klimapp, klim app, climbing app, bananacup.be, banana cup, paraclimbing, paraklimmen, log climbs, climbing logger, climbing logger with heart rate monitor, paraklimmen.be"
        path="/"
      />
      {redirectPath ? <Navigate to={redirectPath} /> : null}
    </>
  );
};

export default HomeRedirect;
